import React from 'react';
import { CookieConsent } from '@flowus/common';
import { useTranslation } from 'react-i18next';
import { $searchParams } from 'src/utils';

export const CookieConsentWrapper: React.FC = () => {
  // @ts-ignore: TS2589 Type instantiation is excessively deep
  const { t } = useTranslation();

  if ($searchParams.print) {
    return null;
  }

  return (
    <CookieConsent
      className="print:hidden"
      title={t('cookieConsent.title', 'We use cookies')}
      description={t(
        'cookieConsent.description',
        'We use cookies to improve your experience on our site. By clicking "Accept all", you agree to the storing of cookies on your device for functional and advertising purposes.'
      )}
      acceptText={t('cookieConsent.accept', 'Accept all')}
      declineText={t('cookieConsent.decline', 'More options')}
      doneText={t('cookieConsent.done', 'Done')}
      strictlyNecessaryText={t('cookieConsent.strictlyNecessary', 'Strictly Necessary')}
      functionalText={t('cookieConsent.functional', 'Functional')}
      analyticsText={t('cookieConsent.analytics', 'Analytics')}
      marketingText={t('cookieConsent.marketing', 'Marketing')}
      simplerChoicesText={t('cookieConsent.simplerChoices', '« Simpler choices')}
      cookieName="FLOWUS_COOKIE_CONSENT_ACCEPTED"
      domain="" // 本地调试时不需要跨域 domain，如果要复用可结合环境变量配置
    />
  );
};
